import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '@/assets/app/css/sources.module.css';
import sourceImg from '@/assets/app/images/mypage/source.png';
import TitleHeader from '../common/TitleHeader';

const Sources: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <TitleHeader title="자료출처" onBack={() => navigate(-1)} />

      <main className="px-6 py-2 flex flex-col items-center">
        <div className="w-48 mb-8">
          <img src={sourceImg} alt="Book Cover" className="w-full" />
        </div>

        <div className="w-full space-y-6">
          <section>
            <h3 className="font-bold text-gray-800 mb-2">책소개</h3>
            <p className="text-[#7F7F7F]" style={{ fontSize: 14, lineHeight: 'normal' }}>
              길벗스쿨 〈읽자마자 왕〉은 초등 입학 전후의 친구들을 위해 초등학교 가기 전 필요한 기초
              상식과 공부거리들을 재미있게 미리 경험하도록 만든 시리즈이다. 세 번째 책 《읽자마자
              역사 왕 : 한국을 빛낸 100명의 위인들》은 1990년대에 나온 동요인 ‘한국을 빛낸 100명의
              위인들’ 노랫말에 나오는 우리 역사 속 100명 인물을 소개하고 있다. 학교 가기 전
              친구들부터 초등 저학년까지 친구들이 중요 위인은 물론 한국사의 큰 흐름을 머릿속에 그릴
              수 있도록 도와준다.
            </p>
          </section>

          <section>
            <h3 className="font-bold text-gray-800 mb-1">판매처 링크</h3>
            <a
              href="https://smartstore.naver.com/tomtomistore/products/12600176225"
              target="_blank"
              className="text-[#14A1C8] text-sm font-medium underline font-bold break-all"
            >
              https://smartstore.naver.com/tomtomistore/products/12600176225
            </a>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Sources;
